export default __webpack_public_path__ + "static/media/tornado-background.152bd957.jpg";